// Metadades PWA mentre ControlHorariApp està muntat.
// Safari llegeix el manifest en parsejar public/index.html (segons la URL).
// Aquí es manté la coherència si s'entra per navegació interna i, en sortir,
// es deixa sempre el manifest/icona de l'ERP (no el valor que hi hagués
// en muntar, que a /Control_Horari ja seria el de Control Horari).

const MANIFEST_CH = "/manifest-control-horari.json";
const MANIFEST_ERP = "/manifest.json";
const ICONA_APPLE_CH = "/icon-180.png";
const ICONA_APPLE_ERP = "/logo192.png";
const TITOL_CH = "Control Horari";
const TITOL_ERP = "React App";

const METAS_APPLE = [
  { name: "apple-mobile-web-app-capable", content: "yes" },
  { name: "apple-mobile-web-app-title", content: "Control Horari" },
  { name: "apple-mobile-web-app-status-bar-style", content: "default" },
];

function aplicarLink(rel, hrefNou, hrefErp) {
  let node = document.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement("link");
    node.setAttribute("rel", rel);
    document.head.appendChild(node);
  }
  node.setAttribute("href", hrefNou);
  return () => {
    node.setAttribute("href", hrefErp);
  };
}

function assegurarMetaApple(name, content) {
  let node = document.querySelector(`meta[name="${name}"]`);
  if (!node) {
    node = document.createElement("meta");
    node.setAttribute("name", name);
    document.head.appendChild(node);
  }
  node.setAttribute("content", content);
  return () => {
    node.remove();
  };
}

export function chAplicarCapcaleraPwa() {
  if (typeof document === "undefined") return () => {};

  document.title = TITOL_CH;

  const restaurarManifest = aplicarLink("manifest", MANIFEST_CH, MANIFEST_ERP);
  const restaurarAppleIcon = aplicarLink("apple-touch-icon", ICONA_APPLE_CH, ICONA_APPLE_ERP);
  const restaurarMetas = METAS_APPLE.map(({ name, content }) => assegurarMetaApple(name, content));

  return () => {
    document.title = TITOL_ERP;
    restaurarManifest();
    restaurarAppleIcon();
    restaurarMetas.forEach((restaurar) => restaurar());
  };
}
